import axios from 'axios';

/** Best-effort message from a failed axios/API call for user-visible copy. */
export function getApiErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    const data = err.response?.data;

    if (data && typeof data === 'object' && !Array.isArray(data)) {
      const d = data as { error?: string; feature?: string };
      if (d.feature === 'multi_user') {
        return 'Opening practice to teammates requires an Enterprise plan with multi-user practice.';
      }
      if (typeof d.error === 'string' && d.error.trim()) {
        return d.error;
      }
    }

    if (typeof data === 'string' && data.trim()) {
      const t = data.trim().slice(0, 280);
      return t.length < 280 ? t : `${t}…`;
    }

    if (status != null) {
      const base = err.message || 'Request failed';
      return `${base} (HTTP ${status})`;
    }

    return err.message || 'Network error — check your connection and API URL.';
  }

  if (err instanceof Error) {
    return err.message;
  }

  return 'Something went wrong.';
}
